function endsWith(str, target, position = str.length) {
    return str.endsWith(target, position);
}

export { endsWith };
